import { Component, OnInit, Input } from '@angular/core';
import { TarifCodeService } from 'src/app/shared/services/tarif-code.service';

@Component({
  selector: 'app-expertise-tarif-view',
  templateUrl: './expertise-tarif-view.component.html',
  styleUrls: ['./expertise-tarif-view.component.scss']
})
export class ExpertiseTarifViewComponent implements OnInit {


	@Input() expertise: any;

	public tarifs: any[] = [];

  	constructor(
		  private tarifCodeService: TarifCodeService
	  ) { }

  	ngOnInit() {
		this.tarifCodeService.get().pipe(
		).subscribe(t => this.tarifs = t);
  	}

}
